import { makeAutoObservable } from "mobx";

import type { RootStore } from "@/store";
import type { RichTranslationValues } from "next-intl";

export type HintKey = keyof IntlMessages["hints"]["items"];

export type HintParams = RichTranslationValues;

export type Hint = {
  key: HintKey;
  params?: HintParams;
};

export class HintsStore {
  rootStore: RootStore;

  private _hint: Hint | null = null;

  private timeoutId: NodeJS.Timeout | null = null;

  static readonly HINT_SHOW_DELAY_MS = 300;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  get hint(): Hint | null {
    if (this.rootStore.view.isHintsPanelVisible) {
      return this._hint;
    }

    return null;
  }

  set hint(newHint: Hint | null) {
    if (!this.rootStore.view.isHintsPanelVisible) {
      return;
    }

    if (newHint) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      this._hint = newHint;
    } else {
      this.timeoutId = setTimeout(() => {
        this._hint = null;
      }, HintsStore.HINT_SHOW_DELAY_MS);
    }
  }

  dispose() {
    this._hint = null;

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
}
